import { ScopeProvider } from 'jotai-scope'
import { match } from 'ts-pattern'

import { Container } from './common/layout'
import {
  CreateLineItem,
  createLineItemAtoms,
  CreateLineItemGroup,
  createLineItemGroupAtoms,
  EditLineItem,
  editLineItemAtoms,
  EditLineItemGroup,
  editLineItemGroupAtoms
} from './variants'
import { BaseConfig, VariantConfig } from './types'
import { secondaryOptionsVisibleAtom } from './common/atoms'

type LineItemEditorProps = {
  config: VariantConfig | null
  setLineItemEditor: (config: VariantConfig | null) => void
} & BaseConfig

export const LineItemEditor = ({
  config,
  setLineItemEditor,
  ...baseConfig
}: LineItemEditorProps) => {
  if (!config) return null

  return (
    <ScopeProvider
      atoms={[
        ...createLineItemGroupAtoms,
        ...createLineItemAtoms,
        ...editLineItemGroupAtoms,
        ...editLineItemAtoms,
        secondaryOptionsVisibleAtom
      ]}
    >
      <Container>
        {match(config)
          .with({ variant: 'CREATE_LINE_ITEM_GROUP' }, variantConfig => (
            <CreateLineItemGroup {...baseConfig} {...variantConfig} />
          ))
          .with({ variant: 'CREATE_LINE_ITEM' }, variantConfig => (
            <CreateLineItem
              {...baseConfig}
              {...variantConfig}
              key={variantConfig.key}
              setLineItemEditor={setLineItemEditor}
            />
          ))
          .with({ variant: 'EDIT_LINE_ITEM_GROUP' }, variantConfig => (
            <EditLineItemGroup {...baseConfig} {...variantConfig} />
          ))
          .with({ variant: 'EDIT_LINE_ITEM' }, variantConfig => (
            <EditLineItem {...baseConfig} {...variantConfig} />
          ))
          .exhaustive()}
      </Container>
    </ScopeProvider>
  )
}
